import { TaxonomyName } from "domain";

export const initState = {
    list: [],
    searchResults: [],
    current: null,
    isLoading: false,
    isSearching: false,
    hasFailed: false,
    searchTerm: ''
};

export default function taxonomyNameReducer(state = initState, action) {
    const { type, payload } = action;

    switch (type) {
        case 'LIST_TAXONOMY_NAME_PENDING': {
            return { ...state, isLoading: true, hasFailed: false };
        }

        case 'LIST_TAXONOMY_NAME_REJECTED': {
            return { ...state, isLoading: false, hasFailed: true };
        }

        case 'LIST_TAXONOMY_NAME_FULFILLED': {
            return {
                ...state,
                list: payload.map(item => new TaxonomyName(item)),
                isLoading: false,
                hasFailed: false
            };
        }

        case 'GET_TAXONOMY_NAME_PENDING': {
            return { ...state, isLoading: true, hasFailed: false };
        }

        case 'GET_TAXONOMY_NAME_REJECTED': {
            return { ...state, isLoading: false, hasFailed: true };
        }

        case 'GET_TAXONOMY_NAME_FULFILLED': {
            return {
                ...state,
                current: new TaxonomyName(payload),
                isLoading: false,
                hasFailed: false
            };
        }

        case 'SEARCH_TAXONOMY_NAME_PENDING': {
            return { 
                ...state, 
                isSearching: true, 
                hasFailed: false,
                searchTerm: action.meta.searchTerm 
            };
        }

        case 'SEARCH_TAXONOMY_NAME_REJECTED': {
            return { 
                ...state, 
                isSearching: false, 
                hasFailed: true 
            };
        }

        case 'SEARCH_TAXONOMY_NAME_FULFILLED': {
            const skip = action.meta.skip || 0;
            const newResults = payload.map(item => new TaxonomyName(item));
            
            return {
                ...state,
                searchResults: skip === 0 
                    ? newResults 
                    : [...state.searchResults, ...newResults],
                isSearching: false,
                hasFailed: false
            };
        }

        default: {
            return state;
        }
    }
}
